import Vue from 'vue'
import VueRouter from 'vue-router';
//import VueCanCan from 'vue-cancan';
Vue.use(VueRouter);

import HomeIndex from '../components/home/index.vue';
import DashboardIndex from '../components/home/dashboard.vue';
import DashboardGoalsIndex from '../components/home/dashboard_goals.vue';

import DashboardAltavendaIndex from '../components/home/dashboard_altavenda.vue';

import NotFound from '../components/home/not_found.vue';
import Restricted from '../components/home/restricted.vue';

import WebSite from './site.vue';
import PrivacyPolicy from './privacy_policy.vue';

// import EditableTable from '../components/models/variety_balances/index.vue';
import VarietyBalanceIndex from '../components/models/variety_balances/index.vue';

import ItemWeightIndex from '../components/models/item_weights/index.vue';

import ProductionCostReportIndex from '../components/reports/productions/production_cost.vue';
import ProductionCostPlanningReportIndex from '../components/reports/productions/planning_production_cost.vue';
import ProductionResultReportIndex from '../components/reports/productions/production_result.vue';

import SeedlingProductionResultReportIndex from '../components/reports/productions/seedling_production_result.vue';

import ProductivityReportIndex from '../components/reports/productions/productivity.vue';
import ChartOfAccountsReportIndex from '../components/reports/chart_of_accounts/index.vue';
import StockInventoryReportIndex from '../components/reports/storages/stock_inventory.vue';
import StorageInventoryReportIndex from '../components/reports/storages/storage_inventory.vue';
import InventoryWMSReportIndex from '../components/reports/storages/inventory_wms.vue';
import ExecutionOperationsReportIndex from '../components/reports/operations/execution_index.vue';
import PlanningOperationsReportIndex from '../components/reports/operations/planning_index.vue';
import PlanningExecutionOperationsReportIndex from '../components/reports/operations/planning_execution_index.vue';
import SalesByProductSyntheticReportIndex from '../components/reports/sales/sales_by_product_synthetic_index.vue';
import SalesByProductSyntheticAltavendaReportIndex from '../components/reports/sales/sales_by_product_synthetic_altavenda_index.vue';
import SalesByProductAnalyticReportIndex from '../components/reports/sales/sales_by_product_analytic_index.vue';
import SalesByCustomerAnalyticReportIndex from '../components/reports/sales/sales_by_customer_analytic_index.vue';
import LotOperationViewIndex from '../components/reports/productions/lot_operations_index.vue';

import SaleLotViewIndexFilterIndex from '../components/models/manufacturing_lots/sale_lots/index.vue';

import SalesProductByCustomerAnalyticReportIndex from '../components/reports/sales/sales_product_by_customer_analytic_index.vue';
import StorageMovementsReportIndex from '../components/reports/storages/storage_movements.vue';

import HarvestPlanningReportIndex from '../components/reports/harvests/harvest_planning.vue';
import HarvestExecutionReportIndex from '../components/reports/harvests/harvest_execution.vue';

import EndProductsIndex from '../components/models/items/end_products/index.vue';

import TaxationGroupIndex from '../components/models/fiscal_documents/outbounds/taxation_groups/index.vue';
import CfopIndex from '../components/models/fiscal_documents/outbounds/cfops/index.vue';

import TaxationRuleIndex from '../components/models/fiscal_documents/outbounds/taxation_groups/taxation_rules/index.vue';

import MemoriesIndex from '../components/models/memories/index.vue'

import SalesIndex from '../components/models/sales/index.vue';
import SaleOrdersIndex from '../components/models/sales/sale_orders/index.vue';
import CashBookIndex from '../components/reports/financials/cash_book.vue';
import ProjectedCashBookIndex from '../components/reports/financials/projected_cash_book.vue';
import AvailableProductionIndex from '../components/reports/productions/available_production.vue'
import SeedlingAvailableProductionIndex from '../components/reports/productions/seedling_available_production.vue'
import SeedlingByPeriodIndex from '../components/reports/seedlings/seedling_by_period_index.vue'
import SeedlingPlantingMapaIndex from '../components/reports/seedlings/seedling_planting_mapa_index.vue'

import SeedlingYearProductionReport from '../components/reports/seedlings/seedling_year_report.vue'

import SeedlingProductionCostReport from '../components/reports/seedlings/seedling_production_cost_report.vue'

import LabelIndex from '../components/models/labels/index.vue';

import PurchasesIndex from '../components/models/purchases/index.vue';
import CashInflowIndex from '../components/models/cash_flows/cash_inflows/index.vue';
import CashInflowInstallmentsIndex from '../components/models/installments/cash_inflow_installments/index.vue';
import CashOutflowIndex from '../components/models/cash_flows/cash_outflows/index.vue';
import CashOutflowInstallmentsIndex from '../components/models/installments/cash_outflow_installments/index.vue';

import TablePricesIndex from '../components/models/table_prices/index.vue';

import PaymentConditionRulesIndex from '../components/models/payment_condition_rules/index.vue';

import TablePriceProductsIndex from '../components/models/table_price_products/index.vue'

import TablePriceItemsIndex from '../components/models/table_price_items/index.vue'

import FieldsIndex from '../components/models/fields/index.vue';

import RoutesIndex from '../components/models/routes/index.vue';

import PeriodsIndex from '../components/models/periods/index.vue';

import StocksIndex from '../components/models/stocks/index.vue';
import StockTransfersIndex from '../components/models/stocks/stock_transfers/index.vue';
import StockAdjustmentReasonsIndex from '../components/models/stocks/stock_adjustments/stock_adjustment_reasons/index.vue';
import StockAdjustmentsIndex from '../components/models/stocks/stock_adjustments/index.vue';

import LossesIndex from '../components/models/losses/index.vue';

import StoragesIndex from '../components/models/storages/index.vue';
import StorageShelvesIndex from '../components/models/storage_shelves/index.vue';
import StorageAdjustmentsIndex from '../components/models/storages/storage_adjustments/index.vue';
import StorageTransfersIndex from '../components/models/storages/storage_transfers/index.vue'

import GreenhouseIndex from '../components/models/greenhouses/index.vue';

import ItemTransformationsIndex from '../components/models/storages/item_transformations/index.vue'

import PeriodLossReasonsIndex from '../components/models/periods/period_losses/period_loss_reasons/index.vue';
import PeriodLossesIndex from '../components/models/periods/period_losses/index.vue';

import StorehousesIndex from '../components/models/storehouses/index.vue';

import HarvestsIndex from '../components/models/harvests/index.vue';

import ServicesProvisionIndex from '../components/models/services_provision/index.vue';
import PatrimoniesIndex from '../components/models/patrimonies/index.vue';

import PeopleIndex from  '../components/models/people/index.vue';
import PeopleAltavendaIndex from  '../components/models/people/altavenda_index.vue';

import RegionsIndex from  '../components/models/regions/index.vue';

import AgendasIndex from  '../components/models/agendas/index.vue';

import GoalsIndex from  '../components/models/goals/index.vue';

import BankAccountsIndex from  '../components/models/bank_accounts/index.vue';
import BankAccountOperationsIndex from  '../components/models/bank_accounts/bank_account_operations/index.vue';

import NfpeOutboundIndex from '../components/models/fiscal_documents/outbounds/nfes/nfpes/index.vue';
import NfceOutboundIndex from '../components/models/fiscal_documents/outbounds/nfes/nfces/index.vue';
import MdfeOutboundIndex from '../components/models/fiscal_documents/outbounds/mdfes/index.vue';
import NfseOutboundIndex from '../components/models/fiscal_documents/outbounds/nfses/index.vue';

import AccountsIndex from '../components/models/accounts/index.vue';
import GroundsIndex from '../components/models/grounds/index.vue';
import GroupsIndex from '../components/models/groups/index.vue';
import BrandsIndex from '../components/models/brands/index.vue';
import PackagingsIndex from '../components/models/packagings/index.vue';
import PartsIndex from '../components/models/items/parts/index.vue';
import OilsIndex from '../components/models/items/oils/index.vue';
import OthersIndex from '../components/models/items/others/index.vue';
import ToolsIndex from '../components/models/items/tools/index.vue';
import ExecutionOperationIndex from '../components/models/operations/execution_operations/index.vue';
import SeedPlotOperationIndex from '../components/models/operations/seed_plot_operations/index.vue';

import AvailableCropLotsIndex from '../components/models/manufacturing_lots/crop_lots/index.vue';

import ChartOfAccountsIndex from '../components/models/chart_of_accounts/index.vue'

import PlanningsIndex from '../components/models/operations/planning_operations/index.vue'
import PlanningSeedPlotOperationsIndex from '../components/models/operations/planning_seed_plot_operations/index.vue'

import UsersIndex from '../components/models/users/index.vue'

import CulturesIndex from '../components/models/cultures/index.vue'
import SubCulturesIndex from '../components/models/sub_cultures/index.vue'
import VarietiesIndex from '../components/models/varieties/index.vue'
import SeedsIndex from '../components/models/items/seeds/index.vue'
import SeedlingsIndex from '../components/models/items/seedlings/index.vue'
import AgrotoxicsIndex from '../components/models/items/agrotoxics/index.vue'
import ActiveIngredientsIndex from '../components/models/items/agrotoxics/active_ingredients/index.vue'
import FertilizersIndex from '../components/models/items/fertilizers/index.vue'
import BiologicalsIndex from '../components/models/items/biologicals/index.vue'
import OperationTypesIndex from '../components/models/operations/operation_types/index.vue'
import PatrimonyCategoriesIndex from '../components/models/patrimonies/patrimony_categories/index.vue'

const router = new VueRouter(
  {
    mode: 'history',
    routes: [
      {
        path: "/",
        name: "Site",
        component: WebSite,
      },
      {
        path: "/privacy_policy",
        name: "Política de Privacidade",
        component: PrivacyPolicy,
      },
      {
        path: "/app/variety_balances",
        name: "VarietyBalance",
        component: VarietyBalanceIndex,
        meta: {
          title: "Saldo das Variedades"
        },
      },
      {
        path: "/app/item_weights",
        name: "ItemWeight",
        component: ItemWeightIndex,
        meta: {
          title: "Pesos dos itens"
        },
      },
      {
        path: '/app/', component: HomeIndex,
        name: 'Home',
      }, 
      {
        path: '/app/dashboard', component: DashboardIndex,
        name: 'Dashboard',
      },
      {
        path: '/app/dashboard_goals', component: DashboardGoalsIndex,
        name: 'DashboardGoal',
      },
      {
        path: '/app/dashboard_altavenda', component: DashboardAltavendaIndex,
        name: 'DashboardAltavenda',
      }, 
      {
        path: '/app/production_cost_report', component: ProductionCostReportIndex,
        name: 'ProductionCostReport',
        meta: {
          title: "Relatório de Custo de Produção"
        }
      }, 
      {
        path: '/app/production_cost_planning_report', component: ProductionCostPlanningReportIndex,
        name: 'ProductionCostPlanningReport',
        meta: {
          title: "Relatório de Custo Planejado de Produção"
        }
      }, 
      {
        path: '/app/stock_inventory_report', component: StockInventoryReportIndex,
        name: 'StockInventoryReport',
        meta: {
          title: "Relatório de Inventário de Estoque"
        }
      },
      {
        path: '/app/storage_inventory_report', component: StorageInventoryReportIndex,
        name: 'StorageInventoryReport',
        meta: {
          title: "Relatório de Inventário de Estoque"
        }
      },
      {
        path: '/app/inventory_wms_report', component: InventoryWMSReportIndex,
        name: 'InventoryWMSReport',
        meta: {
          title: "Relatório WMS"
        }
      },
      {
        path: '/app/execution_operations_report', component: ExecutionOperationsReportIndex,
        name: 'ExecutionOperationsReport',
        meta: {
          title: "Relatório de Operações Realizadas"
        }
      }, 
      {
        path: '/app/planning_operations_report', component: PlanningOperationsReportIndex,
        name: 'PlanningOperationsReport',
        meta: {
          title: "Relatório de Operações Planejadas"
        }
      }, 
      {
        path: '/app/planning_execution_operations_report', component: PlanningExecutionOperationsReportIndex,
        name: 'PlanningExecutionOperationsReport',
        meta: {
          title: "Relatório de Operações Planejadas x Realizadas"
        }
      }, 
      {
        path: '/app/sales_by_product_synthetic_report', component: SalesByProductSyntheticReportIndex,
        name: 'SalesByProductSyntheticReport',
        meta: {
          title: "Relatório de Vendas por Produto - Sintético"
        }
      }, 
      {
        path: '/app/sales_by_product_synthetic_altavenda_report', component: SalesByProductSyntheticAltavendaReportIndex,
        name: 'SalesByProductSyntheticAltavendaReport',
        meta: {
          title: "Relatório de Vendas por Produto - Sintético"
        }
      }, 
      {
        path: '/app/sales_by_product_analytic_report', component: SalesByProductAnalyticReportIndex,
        name: 'SalesByProductAnalyticReport',
        meta: {
          title: "Relatório de Vendas por Produto - Analítico"
        }
      },
      {
        path: '/app/sales_by_customer_analytic_report', component: SalesByCustomerAnalyticReportIndex,
        name: 'SalesByCustomerAnalyticReport',
        meta: {
          title: "Relatório de Vendas por Cliente - Analítico"
        }
      },
      {
        path: '/app/lot_operations_index', component: LotOperationViewIndex,
        name: 'LotOperationView',
        meta: {
          title: "Operações em lotes"
        }
      },
      {
        path: '/app/sales_product_by_customer_analytic_report', component: SalesProductByCustomerAnalyticReportIndex,
        name: 'SalesProductByCustomerAnalyticReport',
        meta: {
          title: "Relatório de Produtos de Venda por Cliente - Analítico"
        }
      },
      {
        path: '/app/storage_movements_report', component: StorageMovementsReportIndex,
        name: 'StorageMovementsReport',
        meta: {
          title: "Relatório de Movimentação de Estoque"
        }
      },
      {
        path: '/app/production_result_report', component: ProductionResultReportIndex,
        name: 'ProductionResultReport',
        meta: {
          title: "Relatório de Resultado de Produção"
        }
      },
      {
        path: '/app/production_result_report', component: SeedlingProductionResultReportIndex,
        name: 'SeedlingProductionResultReport',
        meta: {
          title: "Relatório de Resultado de Produção (Viveiro)"
        }
      },      
      {
        path: '/app/productivity_report', component: ProductivityReportIndex, 
        name: 'ProductivityReport',
        meta: {
          title: "Relatório de Produtividade e Área Plantada"
        }
      }, 
      {
        path: '/app/chart_of_accounts_report', component: ChartOfAccountsReportIndex,
        name: 'ChartOfAccountsReport',
        meta: {
          title: "Relatório de Plano de Contas/Competência Caixa"
        }
      },  
      {
        path: '/app/available_production_report', component: AvailableProductionIndex,
        name: 'AvailableProductionReport',
        meta: {
          title: "Disponibilidade de Produção"
        }
      },
      {
        path: '/app/seedling_available_production_report', component: SeedlingAvailableProductionIndex,
        name: 'AvailableProductionViewReport',
        meta: {
          title: "Disponibilidade de Produção (Viveiro)"
        }
      },
      {
        path: '/app/seedling_by_period_report', component: SeedlingByPeriodIndex,
        name: 'SeedlingByPeriodReport',
        meta: {
          title: "Mudas por Ciclo"
        }
      },
      {
        path: '/app/seedling_planting_mapa_report', component: SeedlingPlantingMapaIndex,
        name: 'SeedlingPlantingMapaReport',
        meta: {
          title: "Semeios MAPA"
        }
      },
      {
        path: '/app/seedling_year_production_report', component: SeedlingYearProductionReport,
        name: 'SeedlingYearProductionReport',
        meta: {
          title: "Relatório Anual de Produção"
        }
      },
      {
        path: '/app/seedling_production_cost_report', component: SeedlingProductionCostReport,
        name: 'SeedlingProductionCostReport',
        meta: {
          title: "Relatório de Custo de Produção"
        }
      },
      {
        path: '/app/end_products', component: EndProductsIndex,
        name: 'EndProduct',
        meta: {
          title: "Produtos Produzidos"
        }
      },
      {
        path: '/app/cash_book/:bankAccountId?', component: CashBookIndex,
        name: 'CashBook',
        meta: {
          title: "Fluxo de Caixa"
        }
      }, 
      {
        path: '/app/projected_cash_book/:bankAccountId?', component: ProjectedCashBookIndex,
        name: 'ProjectedCashBook',
        meta: {
          title: "Fluxo de Caixa Projetado"
        }
      },
      {
        path: '/app/nfe/outbound/taxation_groups', component: TaxationGroupIndex,
        name: 'TaxationGroup',
        meta: {
          title: "Grupos de Tributação"
        }
      },
      {
        path: '/app/nfe/outbound/cfops', component: CfopIndex,
        name: 'Cfop',
        meta: {
          title: "CFOPs"
        }
      },
      {
        path: '/app/nfe/outbound/taxation_rules/:taxationGroupId?', component: TaxationRuleIndex,
        name: 'TaxationRule',
        meta: {
          title: "Regras de Tributação"
        }
      },
      {
        path: '/app/sales',
        name: 'Sale',
        component: SalesIndex,
        meta: {
          title: "Vendas"
        }
      }, 
      {
        path: '/app/sale_orders',
        name: 'SaleOrder',
        component: SaleOrdersIndex,
        meta: {
          title: "Pedidos de Vendas"
        }
      },
      {
        path: '/app/purchases',
        name: 'Purchase',
        component: PurchasesIndex,
        meta: {
          title: "Compras"
        }
      },
      {
        path: '/app/cash_inflows',
        name: 'CashInflow',
        component: CashInflowIndex,
        meta: {
          title: "Contas a Receber"
        }
      },
      {
        path: '/app/cash_inflow_installments',
        name: 'CashInflowInstallment',
        component: CashInflowInstallmentsIndex,
        meta: {
          title: "Parcelas de Recebimentos (Contas a Receber e Vendas)"
        }
      },
      {
        path: '/app/cash_outflows',
        name: 'CashOutflow',
        component: CashOutflowIndex,
        meta: {
          title: "Contas a Pagar"
        }
      },
      {
        path: '/app/cash_outflow_installments',
        name: 'CashOutflowInstallment',
        component: CashOutflowInstallmentsIndex,
        meta: {
          title: "Parcelas de Pagamentos (Contas a Pagar e Compras)"
        }
      },
      {
        path: '/app/table_prices',
        name: 'TablePrice',
        component: TablePricesIndex,
        meta: {
          title: "Tabela de precos"
        }
      },
      {
        path: '/app/table_price_products',
        name: 'TablePriceProduct',
        component: TablePriceProductsIndex,
        meta: {
          title: "Tabela preco produto"
        }
      },
       {
        path: '/app/table_price_items',
        name: 'TablePriceItem',
        component: TablePriceItemsIndex,
        meta: {
          title: "Tabela preco item"
        }
      },
      {
        path: '/app/payment_condition_rules',
        name: 'PaymentConditionRule',
        component: PaymentConditionRulesIndex,
        meta: {
          title: "Condicoes de pagamento"
        }
      },
      {
        path: '/app/patrimonies', component: PatrimoniesIndex,
        name: 'Patrimony',
        meta: {
          title: "Patrimônios"
        }
      },
      {
        path: '/app/fields', component: FieldsIndex,
        name: 'Field',
        meta: {
          title: "Lista de Talhões"
        }
      },
      {
        path: '/app/routes', component: RoutesIndex,
        name: 'Route',
        meta: {
          title: "Lista de Rotas"
        }
      },
      {
        path: '/app/periods', component: PeriodsIndex,
        name: 'Period',
        meta: {
          title: "Lista de Ciclos"
        }
      },
      {
        path: '/app/harvests', component: HarvestsIndex,
        name: 'Harvest',
        meta: {
          title: "Lista de Safras"
        }
      },
      {
        path: '/app/stocks', component: StocksIndex,
        name: 'Stock',
        meta: {
          title: "Lista de Estoques"
        }
      },  
      {
        path: '/app/storages', component: StoragesIndex,
        name: 'Storage',
        meta: {
          title: "Lista de Armazenagens"
        }
      },           
      {
        path: '/app/greenhouses', component: GreenhouseIndex,
        name: 'Greenhouse',
        meta: {
          title: "Estufas"
        }
      },
      {
        path: '/app/storage_shelves', component: StorageShelvesIndex,
        name: 'StorageShelf',
        meta: {
          title: "Lista de Estantes"
        }
      }, 
      {
        path: '/app/stock_adjustment_reasons', component: StockAdjustmentReasonsIndex,
        name: 'StockAdjustmentReason',
        meta: {
          title: "Motivos de Ajustes de Estoques"
        }
      },
      {
        path: '/app/stock_adjustments', component: StockAdjustmentsIndex,
        name: 'StockAdjustment',
        meta: {
          title: "Ajustes de Estoques"
        }
      }, 
      {
        path: '/app/storage_adjustments', component: StorageAdjustmentsIndex,
        name: 'StorageAdjustment',
        meta: {
          title: "Ajustes de Estoque"
        }
      },
      {
        path: '/app/losses', component: LossesIndex,
        name: 'Loss',
        meta: {
          title: "Perdas"
        }
      },
       
      {
        path: '/app/period_loss_reasons', component: PeriodLossReasonsIndex,
        name: 'PeriodLossReason',
        meta: {
          title: "Motivos de Perdas em Ciclos"
        }
      },
      {
        path: '/app/period_losses', component: PeriodLossesIndex,
        name: 'PeriodLoss',
        meta: {
          title: "Perdas em Ciclos"
        }
      }, 
      {
        path: '/app/stock_transfers', component: StockTransfersIndex,
        name: 'StockTransfer',
        meta: {
          title: "Lista de Transferências de Itens entre Estoques"
        }
      },
      {
        path: '/app/storage_transfers', component: StorageTransfersIndex,
        name: 'StorageTransfer',
        meta: {
          title: "Lista de Transferências de Itens entre Estoques"
        }
      }, 
      {
        path: '/app/item_transformations', component: ItemTransformationsIndex,
        name: 'ItemTransformation',
        meta: {
          title: "Lista de Transformações de Items"
        }
      },
      {
        path: '/app/storehouses', component: StorehousesIndex,
        name: 'Storehouse',
        meta: {
          title: "Lista de Depósitos"
        }
      },
      {
        path: '/app/services_provision', component: ServicesProvisionIndex,
        name: 'ServiceProvision',
        meta: {
          title: "Serviços"
        }
      },
      {
        path: '/app/regions', component: RegionsIndex,
        name: 'Region',
        meta: {
          title: "Regiões"
        }
      },
      {
        path: '/app/agendas', component: AgendasIndex,
        name: 'Agenda',
        meta: {
          title: "Agendas"
        }
      },
      {
        path: '/app/goals', component: GoalsIndex,
        name: 'Goal',
        meta: {
          title: "Metas"
        }
      },
      {
        path: '/app/people', component: PeopleIndex,
        name: 'Person',
        meta: {
          title: "Pessoas"
        }
      },
      {
        path: '/app/people_altavenda', component: PeopleAltavendaIndex,
        name: 'PersonAlta',
        meta: {
          title: "Pessoas"
        }
      },
      {
        path: '/app/labels', component: LabelIndex,
        name: 'Label',
        meta: {
          title: "Etiquetas"
        }
      },
      {
        path: '/app/outbound_nfes', component: NfpeOutboundIndex,
        name: 'OutboundNfe',
        meta: {
          title: "NFP-e de Saída"
        }
      }, 
      {
        path: '/app/outbound_nfces', component: NfceOutboundIndex,
        name: 'OutboundNfce',
        meta: {
          title: "NFC-e de Saída"
        }
      },
      {
        path: '/app/outbound_mdfes', component: MdfeOutboundIndex,
        name: 'OutboundMdfe',
        meta: {
          title: "MDF-e de Saída"
        }
      },
      {
        path: '/app/outbound_nfses', component: NfseOutboundIndex,
        name: 'OutboundNfse',
        meta: {
          title: "NFS-e de Saída"
        }
      },
      {
        path: '/app/grounds', component: GroundsIndex,
        name: 'Ground',
        meta: {
          title: "Áreas"
        }
      }, 
      {
        path: '/app/accounts', component: AccountsIndex,
        name: 'Account',
        meta: {
          title: "Contas"
        }
      },
      {
        path: '/app/memories', component: MemoriesIndex,
        name: 'Memory',
        meta: {
          title: "Memória"
        }
      },
      {
        path: '/app/brands', component: BrandsIndex,
        name: 'Brand',
        meta: {
          title: "Marcas"
        }
      },
      {
        path: '/app/groups', component: GroupsIndex,
        name: 'Group',
        meta: {
          title: "Grupos de Itens"
        }
      }, 
      {
        path: '/app/packagings', component: PackagingsIndex,
        name: 'Packaging',
        meta: {
          title: "Embalagens"
        }
      }, 
      {
        path: '/app/parts', component: PartsIndex,
        name: 'Part',
        meta: {
          title: "Peças"
        }
      }, 
      {
        path: '/app/oils', component: OilsIndex,
        name: 'Oil',
        meta: {
          title: "Óleos/combustíveis"
        }
      },
      {
        path: '/app/tools', component: ToolsIndex,
        name: 'Tool',
        meta: {
          title: "Ferramentas"
        }
      },
      {
        path: '/app/others', component: OthersIndex,
        name: 'Other',
        meta: {
          title: "Itens Diversos"
        }
      },
      {
        path: '/app/execution_operations', component: ExecutionOperationIndex,
        name: 'ExecutionOperation',
        meta: {
          title: "Operações"
        }
      },
      {
        path: '/app/seed_plot_operations', component: SeedPlotOperationIndex,
        name: 'SeedPlotOperation',
        meta: {
          title: "Operações"
        }
      },
      {
        path: '/app/available_crop_lots', component: AvailableCropLotsIndex,
        name: 'AvailableCropLot',
        meta: {
          title: "Lotes"
        }
      },
      {
        path: '/app/sale_lots', component: SaleLotViewIndexFilterIndex,
        name: 'SaleLotViewIndexFilter',
        meta: {
          title: "Lotes de venda"
        }
      },
      {
        path: '/app/bank_accounts', component: BankAccountsIndex,
        name: 'BankAccount',
        meta: {
          title: "Contas Bancárias"
        }
      },
      {
        path: '/app/bank_account_operations/:bankAccountId?', component: BankAccountOperationsIndex,
        name: 'BankAccountOperation',
        meta: {
          title: "Operações Bancárias"
        }
      }, 
      {
        path: '/app/users', component: UsersIndex,
        name: 'User',
        meta: {
          title: "Usuários"
        }
      }, 
      {
        path: '/app/cultures', component: CulturesIndex,
        name: 'Culture',
        meta: {
          title: "Culturas"
        }
      },
      {
        path: '/app/sub_cultures', component: SubCulturesIndex,
        name: 'SubCulture',
        meta: {
          title: "Subculturas"
        }
      },
      {
        path: '/app/varieties', component: VarietiesIndex,
        name: 'Variety',
        meta: {
          title: "Variedades"
        }
      },
      {
        path: '/app/seeds', component: SeedsIndex,
        name: 'Seed',
        meta: {
          title: "Sementes"
        }
      },
      {
        path: '/app/seedlings', component: SeedlingsIndex,
        name: 'Seedling',
        meta: {
          title: "Mudas"
        }
      },
      {
        path: '/app/agrotoxics', component: AgrotoxicsIndex,
        name: 'Agrotoxic',
        meta: {
          title: "Agrotóxicos"
        }
      }, 
      {
        path: '/app/active_ingredients', component: ActiveIngredientsIndex,
        name: 'ActiveIngredient',
        meta: {
          title: "Ingredientes Ativos"
        }
      },
      {
        path: '/app/fertilizers', component: FertilizersIndex,
        name: 'Fertilizer',
        meta: {
          title: "Fertilizantes"
        }
      },
      {
        path: '/app/biologicals', component: BiologicalsIndex,
        name: 'Biological',
        meta: {
          title: "Biológicos"
        }
      },
      {
        path: '/app/operation_types', component: OperationTypesIndex,
        name: 'OperationType',
        meta: {
          title: "Tipos de Operações"
        }
      },
      {
        path: '/app/patrimony_categories', component: PatrimonyCategoriesIndex,
        name: 'PatrimonyCategory',
        meta: {
          title: "Categorias de Patrimônio"
        }
      },
      {
        path: '/app/planning_operations', component: PlanningsIndex,
        name: 'PlanningOperation',
        meta: {
          title: "Planejamentos"
        }
      },
      {
        path: '/app/planning_seed_plot_operations', component: PlanningSeedPlotOperationsIndex,
        name: 'PlanningSeedPlotOperation',
        meta: {
          title: "Planejamentos"
        }
      },
      {
        path: '/app/harvest_planning_report', component: HarvestPlanningReportIndex,
        name: 'HarvestPlanningReport',
        meta: {
          title: "Relatório de Planejamento de Safra"
        }
      }, 
      {
        path: '/app/harvest_execution_report', component: HarvestExecutionReportIndex,
        name: 'HarvestExecutionReport',
        meta: {
          title: "Relatório de Safra"
        }
      }, 
      {
        path: '/app/chart_of_accounts',
        component: ChartOfAccountsIndex,
        name: 'Chart',
        meta: {
          title: "Plano de Contas"
        }
      },
      {
        path: '/app/restricted',
        component: Restricted,
        name: 'Restricted',
      },
      {
        path: '*', component: NotFound,
        name: 'NotFound',
      },
    ]
  }
);

// console.log(router);

// if (router){
//   router.beforeEach((to, from, next) => {
//     console.log(to, from, next, this, Vue.prototype.$ability.can('read', to.name), to.name);
//     if (to.name && Vue.prototype.$ability && !Vue.prototype.$ability.can('read', to.name)) {
//       next('/restricted');
//     }
//     next();
//   })
// }

// router.afterEach((to, from) => {
//   console.log(to, from, this, Vue.prototype.$ability.can('read', 'ChartOfAccount'), to.name);
// })

export default router;
